export interface ConfigSession {
  activateAdminCookie: boolean;
  cookieName: string;
}

/**
 * #class ConfigSessionService
 */
export class ConfigSessionService {
  /**
   * @property activateAdminCookie
   */
  private _activateAdminCookie: boolean;
  /**
   * @property cookieName
   */
  private _cookieName: string;

  /**
   * #constructor
   */
  constructor(private config: ConfigSession) {
    this._activateAdminCookie = config.activateAdminCookie;
    this._cookieName = config.cookieName;
  }

  /**
   * @method activateAdminCookie
   * @returns boolean
   */
  get activateAdminCookie(): boolean {
    return this._activateAdminCookie;
  }

  /**
   * @method cookieName
   * @returns string
   */
  get cookieName(): string {
    return this._cookieName;
  }
}
